var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9944 29.3229C23.3556 29.3229 29.323 23.3555 29.323 15.9943C29.323 8.63313 23.3556 2.66571 15.9944 2.66571C8.63319 2.66571 2.66577 8.63313 2.66577 15.9943C2.66577 23.3555 8.63319 29.3229 15.9944 29.3229Z",
    stroke: "#E7000B",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.993 11.9957L11.9958 19.9929",
    stroke: "#E7000B",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9958 11.9957L19.993 19.9929",
    stroke: "#E7000B",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose3);
export default __webpack_public_path__ + "static/media/Close3.5ed18722dc6f55f7f3127528379bbfb6.svg";
export { ForwardRef as ReactComponent };